export type CharacterCountLimiterProps = {
  softLimit?: number;
  maxLength?: number;
  showCount?: boolean;
  showCountThreshold?: number;
};

type ShouldRenderCountArgs = CharacterCountLimiterProps & {
  charCount: number;
};

export const getShouldRenderCount = ({
  charCount,
  maxLength,
  softLimit,
  showCount,
  showCountThreshold,
}: ShouldRenderCountArgs): boolean => {
  const limit = showCount !== false && (softLimit || maxLength);

  if (!limit) return false;

  return Boolean(
    !showCountThreshold ||
    (showCountThreshold && limit - charCount <= showCountThreshold),
  );
};

export const getCharacterCountText = ({
  charCount,
  softLimit,
  maxLength,
}: Pick<ShouldRenderCountArgs, 'charCount' | 'maxLength' | 'softLimit'>) =>
  `${charCount}/${softLimit ?? maxLength}`;
